module.exports = __webpack_public_path__ + "static/media/book.8f83fdef.png";